











import { Component, Mixins, Prop } from 'vue-property-decorator';
import colorMainMenu from '@/mixins/colorMainMenu';

import IChildrenToggle from './types';

@Component
export default class ChildrenToggle extends Mixins(colorMainMenu)
  implements IChildrenToggle {
  @Prop({ type: Boolean, default: false })
  readonly sidebarShow!: boolean;

  onClick(): void {
    this.$emit('click');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/toggle/Toggle.vue